import axios from "axios";
import { Stamp, FileText, Download, ShieldCheck } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const LANGS = [
  { code: "sk", label: "SK", suffix: "" },
  { code: "en", label: "EN", suffix: "-en" },
  { code: "de", label: "DE", suffix: "-de" },
  { code: "pl", label: "PL", suffix: "-pl" },
];

const DOCS = [
  {
    key: "consent", Icon: ShieldCheck, title: "Súhlas so spracovaním osobných údajov",
    desc: "GDPR súhlas pre klientov a partnerov.", base: "/suhlas-spracovanie-udajov-saubereko",
  },
  {
    key: "nda", Icon: FileText, title: "NDA — Dohoda o mlčanlivosti",
    desc: "Zmluva o mlčanlivosti pre spoluprácu a partnerov.", base: "/nda-mlcanlivost-timea-saubereko",
  },
];

export default function StaffTemplates({ token }) {
  const openStamp = async () => {
    try {
      const res = await axios.get(`${API}/staff/asset/stamp`, { headers: { Authorization: `Bearer ${token}` }, responseType: "blob" });
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a"); a.href = url; a.download = "saubereko-peciatka.png";
      document.body.appendChild(a); a.click(); a.remove(); URL.revokeObjectURL(url);
    } catch { /* ignore */ }
  };

  return (
    <div data-testid="staff-templates">
      <div className="mb-6">
        <h2 className="font-display text-2xl mb-1">Šablóny a dokumenty</h2>
        <p className="text-white/40 text-sm">Firemná pečiatka a pripravené dokumenty na stiahnutie a podpis.</p>
      </div>

      <div className="grid grid-cols-1 lg:grid-cols-2 gap-4">
        <div className="border border-[#D4AF37]/25 bg-gradient-to-br from-[#D4AF37]/[0.06] to-transparent p-6" data-testid="staff-template-stamp">
          <Stamp className="text-[#D4AF37] mb-3" size={26} />
          <p className="font-display text-xl">Firemná pečiatka SauberEko®</p>
          <p className="text-white/40 text-sm mt-1 mb-4">Oficiálna pečiatka na dokumenty (PNG s priehľadným pozadím).</p>
          <button onClick={openStamp} data-testid="staff-template-stamp-download"
            className="inline-flex items-center gap-2 bg-[#D4AF37] text-black font-semibold px-4 py-2.5 text-sm hover:bg-[#F2E3C6] transition-colors">
            <Download size={15} /> Stiahnuť pečiatku
          </button>
        </div>

        {DOCS.map((d) => (
          <div key={d.key} className="border border-white/10 bg-[#0a0a0a] p-6" data-testid={`staff-template-${d.key}`}>
            <d.Icon className="text-[#D4AF37] mb-3" size={26} />
            <p className="font-display text-xl">{d.title}</p>
            <p className="text-white/40 text-sm mt-1 mb-4">{d.desc}</p>
            <div className="flex flex-wrap gap-2">
              {LANGS.map((l) => (
                <a key={l.code} href={`${d.base}${l.suffix}.pdf`} target="_blank" rel="noreferrer"
                  data-testid={`staff-template-${d.key}-${l.code}`}
                  className="inline-flex items-center gap-1.5 border border-white/15 px-3 py-2 text-xs text-white/75 hover:border-[#D4AF37] hover:text-[#D4AF37] transition-colors">
                  <Download size={13} /> {l.label}
                </a>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
